import { createContext } from 'react';
var SelectContext = createContext({});
export default SelectContext;
